export const CONCIERGE_HERO_IMAGE = {
  desktop: '/images/concierge/hero-figma-root.webp',
  mobile: '/images/concierge/hero-figma-root.webp',
} as const;

export const CONCIERGE_STATS_LEAF_IMAGE = '/images/concierge/stats-leaf.webp';
